import { Paths } from '../../../lib/constants/path'

export const constructOlPath = (path: string, olId: number) =>
  Paths.OL_DETAILS_PAGE.replace(':id', olId.toString()).replace('*', '') + path
